export default function getProductsBySku(sectionWithFops) {
  if (!sectionWithFops || !sectionWithFops.fops) {
    return null;
  }

  return sectionWithFops.fops.reduce((acc, item) => ({
    ...acc,
    ...{ [item.sku]: item.product },
  }), {});
}
